export default __webpack_public_path__ + "static/media/pageLogo.26e9f170.png";